<!--
 * @Descripttion:
 * @Author:
 * @Date: 2020-03-09 09:12:07
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-03-09 10:28:17
 -->
<template>
  <div id="app">
    <router-view v-if="isReload" />
    <Loading v-if="$store.state.showLoading"></Loading>
    <FormulaDlg
      :visible.sync="$store.state.formulaDlg.show"
      @on-formula-img="onFormulaImg"
    ></FormulaDlg>
  </div>
</template>
<script>
import Loading from '@/components/Loading.vue';
import FormulaDlg from '@/components/FormulaDlg';
export default {
  name: 'App',
  components: { Loading, FormulaDlg },
  data() {
    return {
      isReload: true,
    };
  },
  computed: {
    formulaDlg() {
      return this.$store.state.formulaDlg;
    },
  },
  created() {
    this.$eventBus.$on('reload', this.onReload);
  },
  methods: {
    onReload() {
      this.isReload = false;
      this.$nextTick(() => {
        this.isReload = true;
      });
    },
    onFormulaImg(base64) {
      this.$eventBus.$emit(
        'getFormulaImg',
        this.formulaDlg.uid,
        this.formulaDlg.selectionIndex,
        base64,
      );
    },
  },
  metaInfo() {
    return {
      meta: [
        {
          name: 'description',
          content: this.$store.state.webConfig.web_description,
        },
        { name: 'keywords', content: this.$store.state.webConfig.web_keywords },
      ],
    };
  },
};
</script>

<style lang="scss">
@import '@/assets/css/common.scss';
#app {
  height: 100%;
}
</style>
